export default __webpack_public_path__ + "static/Agropalma-601d69da5a7f793374b87aec7d24f441.png";